import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-plan-change',
    templateUrl: './plan-change.component.html',
    styleUrls: ['./plan-change.component.scss']
})
export class PlanChangeComponent implements OnInit {

    user: User = Object.assign({}, EMPTY_USER);
    loading = false;
    loadingStripe = false;
    duration = '';
    plan = '';
    disable = '';
    error = false;
    error_schedule = false;
    simulation = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<PlanChangeComponent>,
        private http: HttpClient,
        public authenticationService: AuthenticationService,
    ) {
        this.duration = data.duration;
        this.plan = data.plan;
        this.disable = data.disable;
        this.user = this.authenticationService.currentUser;
    }

    setDuration(duration) {
        if (duration == this.disable) {
            return
        }
        this.error = false;
        this.error_schedule = false;
        this.duration = duration;
        this.getStripeDetail();
    }

    ngOnInit(): void {
        this.getStripeDetail();
    }

    getStripeDetail() {
        this.loading = true;
        this.http.get<any>(`${environment.apiUrl}app/paiement/update-plan?plan=` + this.plan + `&duration=` + this.duration).subscribe(
            simulation => {
                this.simulation = simulation;
                this.loading = false;
            },
            (error) => {
                console.log(error);
                this.loading = false;
            });
    }

    onYesClick(): void {
        if (this.loadingStripe == false) {
            this.loadingStripe = true
            this.error = false;
            this.error_schedule = false;
            this.http.post<any>(`${environment.apiUrl}app/paiement/update-plan?plan=` + this.plan + `&duration=` + this.duration, {}).subscribe(
                result => {
                    if (result.mode == "up") {
                        window.location.href = "/app/user/plan?success=" + this.plan
                    } else if (result.mode == "down") {
                        window.location.href = "/app/user/plan?success=Schedule"
                    }
                    this.dialogRef.close(true);
                },
                (error) => {
                    console.log(error);
                    if (error == "schedule") {
                        this.error_schedule = true;
                    } else {
                        this.error = true;
                    }
                    this.loadingStripe = false;
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    updateCB() {
        this.dialogRef.close("updateCB");
    }
}
